import { Typography, styled } from "@mui/material"
import useAuth, { KEYCLOAK_ENABLED } from "../../utils/auth"
import { extraColors } from "../../utils/theme"
import { SettingsContainer } from "./shared/SettingsContainer"
import { AuthProviderSelector } from "./AuthProviderSelector"

const InfoItem = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}))

const SettingsContainerStyled = styled(SettingsContainer)(() => ({
  maxWidth: "50%",
}))

export const AccountDetails = () => {
  const { user } = useAuth()

  return (
    <SettingsContainerStyled>
      <InfoItem>
        <Typography variant="small1" color={extraColors.medium}>
          Name
        </Typography>
        <Typography variant="body1">{user?.name}</Typography>
      </InfoItem>
      <InfoItem>
        <Typography variant="small1" color={extraColors.medium}>
          Email
        </Typography>
        <Typography variant="body1">{user?.email}</Typography>
      </InfoItem>
      {KEYCLOAK_ENABLED && <AuthProviderSelector />}
    </SettingsContainerStyled>
  )
}
